/**
 * Глобальная дизайн-система сайта
 * Централизованное хранение цветов, шрифтов и других переменных дизайна
 */

export const colors = {
  // Основная цветовая палитра
  primary: {
    light: '#9A9F6A', // Светлый оливковый
    main: '#808000',  // Оливковый
    dark: '#616000',  // Темный оливковый
  },
  
  // Акцентный цвет
  accent: {
    light: '#E8917C', // Светлый терракотовый
    main: '#E2725B',  // Терракотовый
    dark: '#C15A44',  // Темный терракотовый
  },
  
  // Нейтральные цвета
  neutral: {
    lightest: '#FFFFFF', // Белый
    lighter: '#FAF0E6',  // Лён (фон сайта)
    light: '#F0E6D8',    // Светлый беж
    medium: '#DEB887',   // Дерево
    dark: '#4b5563',     // Темно-серый
    darker: '#374151',   // Очень темно-серый
    darkest: '#1f2937',  // Почти черный
  },
  
  // Дополнительные цвета
  utils: {
    overlay: 'rgba(0, 0, 0, 0.5)',
    lightOverlay: 'rgba(0, 0, 0, 0.25)',
    darkOverlay: 'rgba(0, 0, 0, 0.75)',
  }
};

export const typography = {
  // Семейства шрифтов
  fontFamily: {
    primary: '"Vollkorn", serif',
    legacy: '"Playfair Display", serif',
  },
  
  // Размеры шрифтов
  fontSize: {
    xs: '0.75rem',    // 12px
    sm: '0.875rem',   // 14px
    base: '1rem',     // 16px
    lg: '1.125rem',   // 18px
    xl: '1.25rem',    // 20px
    '2xl': '1.5rem',  // 24px
    '3xl': '1.875rem', // 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem',    // 48px
    '6xl': '3.75rem', // 60px
  },
  
  // Веса шрифтов
  fontWeight: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },
  
  // Высота строки
  lineHeight: {
    none: 1,
    tight: 1.25,
    snug: 1.375,
    normal: 1.5,
    relaxed: 1.625,
    loose: 2,
  },
  
  // Межбуквенный интервал
  letterSpacing: {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0em',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em',
  },
};

export const spacing = {
  xs: '0.25rem',  // 4px
  sm: '0.5rem',   // 8px
  md: '1rem',     // 16px
  lg: '1.5rem',   // 24px
  xl: '2rem',     // 32px
  '2xl': '3rem',  // 48px
  '3xl': '4rem',  // 64px
};

export const breakpoints = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
};

export const shadows = {
  sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
  md: '0 4px 6px rgba(0, 0, 0, 0.1)',
  lg: '0 10px 15px rgba(0, 0, 0, 0.1)',
  xl: '0 20px 25px rgba(0, 0, 0, 0.1)',
};

export const zIndices = {
  base: 0,
  raised: 10,
  dropdown: 50,
  sticky: 100,
  fixed: 200,
  modal: 300,
  tooltip: 400,
};

// Экспортируем всю тему как объект для удобного использования
const theme = {
  colors,
  typography,
  spacing,
  breakpoints,
  shadows,
  zIndices
};

export default theme; 